const Store_SequenceHistory = {
  data: null,
  set: (argData) => (Store_SequenceHistory.data = argData),
};

export default Store_SequenceHistory;
